<!-- Container -->
<div
  class="table-container"
  [ngClass]="displayAdd || displayDelete || displayAdvancedFilter ? 'disable-form' : ''"
>
  <!-- table status container -->
  <div class="display-isloading" *ngIf="displayAdd || displayDelete || displayAdvancedFilter"></div>
  <div [ngClass]="'table-status-' + (loading ? 'loading' : '')">
    <!-- Table controller -->
    <div class="table-controller">
      <ng-content></ng-content>

      <!-- Clear filters button -->
      <div class="filter-controls" *ngIf="configuration.isFilterable">
        <button
          pButton
          type="button"
          icon="pi pi-filter-slash"
          class="p-button-outlined p-button-sm"
          (click)="clearAllFilters()"
          label="Clear Filters"
          title="Clear all filters"
        ></button>
      </div>

      <!-- This is the show row count -->
      <div class="row-dropdown-container">
        <span>
          Show
          <p-dropdown
            class="row-dropdown"
            (onChange)="RefreshTable()"
            [options]="rowNumberList"
            [formControl]="maxRowNumber"
            appendTo="body"
          ></p-dropdown>
          Rows
        </span>
      </div>
    </div>

    <!-- Main Table Component -->
    <p-table
      #dt
      [columns]="cols"
      [value]="data"
      sortMode="multiple"
      [resizableColumns]="true"
      [lazy]="true"
      [lazyLoadOnInit]="false"
      (onLazyLoad)="loadLazy($event)"
      [loading]="loading"
      [paginator]="true"
      [rows]="maxRowNumber.value"
      [totalRecords]="totalRecords"
      [multiSortMeta]="defaultConfiguration.MultiSortMeta"
      [selectionMode]="configuration.selectionMode"
      [(selection)]="selectedRows"
      [(metaKeySelection)]="configuration.metaKeySelection"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="onRowUnselect($event)"
      [autoLayout]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last}"
      [showFirstLastIcon]="false"
      [showPageLinks]="false"
      [showJumpToPageDropdown]="false"
      [showJumpToPageInput]="false"
    >
      <ng-template pTemplate="header" let-editing="editing" let-columns let-ri="rowIndex">
        <!-- Table Row Column Titles -->
        <tr *ngIf="configuration.isFilterable">
          <th
            *ngFor="let col of columns"
            class="no-overflow"
            [ngClass]="{
              'boolean-column': col.type === 'bool',
              'date-column': col.type === 'date',
            }"
            [pSortableColumnDisabled]="!col.sortable"
            [pSortableColumn]="col.field"
            [style.width]="getColumnWidth(col)"
            [style.min-width]="col.minWidth || '60px'"
            pResizableColumn
            [hidden]="col.isHidden"
          >
            {{ col.header }}
            <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
          </th>
        </tr>

        <tr *ngIf="!configuration.isFilterable">
          <th
            *ngFor="let col of columns"
            class="no-overflow"
            [ngClass]="{
              'boolean-column': col.type === 'bool',
              'date-column': col.type === 'date',
            }"
            [style.width]="getColumnWidth(col)"
            [style.min-width]="col.minWidth || '60px'"
            pResizableColumn
            [hidden]="col.isHidden"
          >
            {{ col.header }}
          </th>
        </tr>

        <!-- Table Row Column Field Searches -->
        <tr *ngIf="configuration.isFilterable">
          <th
            *ngFor="let col of cols"
            class="no-overflow"
            [ngClass]="{
              'boolean-column': col.type === 'bool',
              'date-column': col.type === 'date',
            }"
            [formGroup]="searchForm"
            [ngSwitch]="col.type"
            [hidden]="col.isHidden"
          >
            <div *ngSwitchCase="'string'" class="input-text-field-container">
              <button type="button" class="empty-button" (click)="showAdvancedFilterDialog(col)">
                <i class="pi pi-filter"></i>
              </button>
              <input
                class="filter-text-search-input"
                [formControlName]="col.field + 'SearchField'"
                pInputText
                type="text"
                (input)="filterTable($event, col.field, col.matchmode)"
              />
            </div>

            <div *ngSwitchCase="'date'" class="input-field-container">
              <div class="p-calendar p-component p-inputwrapper">
                <input
                  type="date"
                  [formControlName]="col.field + 'SearchField'"
                  class="p-inputtext p-component date-filter-input"
                  [style]="{ width: '100%', 'max-width': '100%' }"
                  (change)="filterDate($event.target.value, false, col.field)"
                  (input)="filterDate($event.target.value, false, col.field)"
                  (focus)="onDateInputFocus($event)"
                  (blur)="onDateInputBlur($event)"
                  [title]="formatDateForDisplay(searchForm.get(col.field + 'SearchField')?.value)"
                  placeholder=""
                />
              </div>
            </div>

            <div *ngSwitchCase="'dropdown'" class="input-field-container">
              <p-dropdown
                [formControlName]="col.field + 'SearchField'"
                appendTo="body"
                [options]="col.dataset"
                [style]="{ width: '100%', minWidth: '100%' }"
                (onChange)="dt.filter($event.value, col.field, 'e')"
              ></p-dropdown>
            </div>

            <div *ngSwitchCase="'bool'" class="input-field-container">
              <p-dropdown
                [formControlName]="col.field + 'SearchField'"
                appendTo="body"
                [options]="booleanDataSet"
                [style]="{ width: '100%', minWidth: '100%' }"
                (onChange)="dt.filter($event.value, col.field, 'e')"
              ></p-dropdown>
            </div>

            <div *ngSwitchCase="'multiselect'" class="input-field-container">
              <p-multiSelect
                [formControlName]="col.field + 'SearchField'"
                appendTo="body"
                [panelStyle]="{ minWidth: '1em' }"
                [options]="col.dataset"
                [defaultLabel]="col.default"
                (onChange)="dt.filter($event.value, col.field, col.matchmode)"
              ></p-multiSelect>
            </div>

            <div *ngSwitchCase="'multiselectcomplex'" class="input-field-container">
              <!-- Always use primeng-multiselect for consistent UI -->
              <primeng-multiselect
                [formControlName]="col.field + 'SearchField'"
                [setUrl]="col.setUrl"
                [columnset]="col.columnset"
                [addedParams]="col.addedComplexFieldsUrlParam['filter']"
                [loadInitialData]="false"
                [isFilterOnly]="true"
                [isSingle]="col.isFilterSingleSelect === true"
                [useExistingDataOnly]="!col.isFilterBackendSearch"
                [allowMultipleFromSearch]="!col.isFilterSingleSelect"
                [baseMaxResults]="1000"
                [pageSize]="50"
                (onChange)="onMultiselectChange($event, col)"
              ></primeng-multiselect>
            </div>

            <div *ngSwitchCase="'action'" class="input-field-container"></div>

            <div *ngSwitchCase="'textarea'" class="input-field-container">
              <textarea
                [formControlName]="col.field + 'SearchField'"
                rows="2"
                style="width: 100%; resize: vertical"
                pInputTextarea
                (input)="filterTable($event, col.field, 'contains')"
              ></textarea>
            </div>
          </th>
        </tr>
      </ng-template>

      <!-- Table Content. With editable components -->
      <ng-template
        pTemplate="body"
        let-data
        let-columns="columns"
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="data" [pSelectableRow]="data" [pSelectableRowIndex]="ri">
          <td
            *ngFor="let col of columns"
            [hidden]="col.isHidden"
            [ngClass]="{
              'clickable-cell': col.isLink,
              'boolean-column': col.type === 'bool',
              'date-column': col.type === 'date',
            }"
          >
            <div *ngIf="col.type === 'action'" class="action-cell">
              <button
                pButton
                type="button"
                [label]="col.actionLabel"
                [icon]="col.actionIcon || ''"
                [class]="col.actionClass || 'p-button-sm p-button-outlined'"
                [title]="col.actionTooltip || col.actionLabel || 'Action'"
                (click)="actionOnClick(col, data)"
              ></button>
            </div>
            <div
              *ngIf="
                col.type !== 'action' &&
                (
                  col.isReadonly ||
                  !configuration.isConfigurable ||
                  !editingObj.isRowBeingEdited[ri] ||
                  (col.isReadonlyOnEdit && editingObj.isRowBeingEdited[ri])
                )
              "
            >
              <div *ngIf="col.isLink">
                <a (click)="linkOnClick(col, data)">
                  <span [ngClass]="{ 'prompt-cell': col.field?.toLowerCase().includes('prompt') }">
                    {{ getValueForTable(col.dataset, data[col.field], col.type) }}
                  </span>
                </a>
              </div>
              <div *ngIf="!col.isLink">
                <span>{{ getValueForTable(col.dataset, data[col.field], col.type, col) }}</span>
              </div>
            </div>
            <div
              class="edit-mode-container"
              [formGroup]="editForm"
              *ngIf="
                !col.isReadonly &&
                !col.isReadonlyOnEdit &&
                configuration.isConfigurable &&
                editingObj.isRowBeingEdited[ri]
              "
              [ngSwitch]="col.type"
            >
              <input
                *ngIf="col.type === 'string'"
                [formControlName]="col.field + ri + 'EditField'"
                [type]="col.accept === 'number' ? 'number' : 'text'"
                [step]="col.accept === 'number' ? 'any' : null"
                [maxlength]="col.limit"
                class="normalized-input"
                pInputText
                (input)="onSelectInput($event, col.field)"
              />

              <input
                *ngSwitchCase="'number'"
                type="text"
                class="normalized-input"
                pInputText
                [formControlName]="col.field + ri + 'EditField'"
                (keypress)="onNumberKeyPress($event)"
              />
              <p-calendar
                *ngSwitchCase="'date'"
                [formControlName]="col.field + ri + 'EditField'"
                appendTo="body"
                dateFormat="dd/mm/yy"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="yearRange"
                [showIcon]="true"
                [autoZIndex]="true"
                [baseZIndex]="1000"
                (onInput)="onSelectInput($event.target.value, col.field)"
                (onSelect)="onSelectInput($event, col.field)"
              ></p-calendar>
              <p-dropdown
                *ngSwitchCase="'dropdown'"
                [formControlName]="col.field + ri + 'EditField'"
                appendTo="body"
                [options]="col.dataset"
                [style]="{ width: '100%', minWidth: 'unset' }"
                (onChange)="onSelectInput($event.value, col.field)"
              ></p-dropdown>
              <p-dropdown
                *ngSwitchCase="'bool'"
                [formControlName]="col.field + ri + 'EditField'"
                appendTo="body"
                [options]="booleanDataSet"
                [style]="{ width: '100%', minWidth: 'unset' }"
                (onChange)="onSelectInput($event.value, col.field)"
              ></p-dropdown>
              <p-multiSelect
                *ngSwitchCase="'multiselect'"
                [formControlName]="col.field + ri + 'EditField'"
                appendTo="body"
                [itemSize]="1"
                [options]="col.dataset"
                [defaultLabel]="col.default"
                (onChange)="editMultiselect($event)"
              ></p-multiSelect>
              <primeng-multiselect
                *ngIf="col.type === 'multiselectcomplex'"
                [formControlName]="col.field + ri + 'EditField'"
                [setUrl]="col.setUrl"
                [columnset]="col.columnset"
                [addedParams]="col.addedComplexFieldsUrlParam['editRow']"
                [loadInitialData]="false"
                [isFilterOnly]="false"
                [isSingle]="col.isSingleSelect || true"
                [useExistingDataOnly]="!col.isFilterBackendSearch"
                (onChange)="ConfigureMultiSelectFieldParams('editRow', ri + 'EditField')"
              ></primeng-multiselect>
              <textarea
                *ngSwitchCase="'textarea'"
                [formControlName]="col.field + ri + 'EditField'"
                rows="2"
                style="width: 100%; resize: vertical"
                pInputTextarea
                readOnly
                (click)="openTextAreaModal(ri, col)"
              ></textarea>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Table Controls -->
      <ng-template *ngIf="configuration.isConfigurable" pTemplate="footer">
        <tr>
          <td [colSpan]="cols.length">
            <div class="multi-controller">
              <div style="width: 30%; text-align-last: start">
                <div class="p-field-checkbox" *ngIf="isMultipleSelectionMode && editCount > 1">
                  <p-checkbox [binary]="true" inputId="editAll" [formControl]="isEditingAll">
                  </p-checkbox>
                  <label for="editAll">Edit All</label>
                </div>
              </div>
              <div style="width: 30%">
                <button
                  pButton
                  *ngIf="configuration.canAdd"
                  type="button"
                  icon="pi pi-plus"
                  class="p-button-info"
                  (click)="showAddRowDialog()"
                  label="Add"
                ></button>
                <button
                  pButton
                  *ngIf="configuration.canEdit"
                  [disabled]="editCount == 0"
                  type="button"
                  icon="pi pi-check"
                  class="p-button-success"
                  (click)="onSelectSave()"
                  label="Save"
                ></button>
                <button
                  pButton
                  *ngIf="configuration.canDelete"
                  [disabled]="selectedRows.length === 0"
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-danger"
                  (click)="showDeleteRowDialog()"
                  label="Delete"
                ></button>
              </div>
              <div style="width: 30%; text-align-last: end">
                <button
                  pButton
                  *ngIf="configuration.canEdit"
                  [disabled]="selectedRows.length === 0"
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-info"
                  (click)="onSelectEdit()"
                  label="Edit"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-times"
                  class="p-button color-cancel"
                  (click)="onSelectCancel()"
                  label="Cancel"
                  [disabled]="editCount == 0"
                ></button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Add new row form -->
    <p-dialog
      header="{{ addFormHeader }}"
      [(visible)]="displayAdd"
      (onHide)="onAddDialogHide()"
      [modal]="true"
      [closable]="true"
      [dismissableMask]="true"
    >
      <div class="add-container" *ngIf="configuration.isConfigurable">
        <div class="display-isloading" *ngIf="displayIsLoading">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <form
          #f="ngForm"
          [formGroup]="addingForm"
          (ngSubmit)="onSelectAdd()"
          [ngClass]="displayIsLoading ? 'disable-form' : ''"
          novalidate
        >
          <div
            class="add-form-container"
            *ngFor="let col of cols"
            [ngSwitch]="col.type"
            [hidden]="col.isHidden"
          >
            <div class="add-row-input-container" *ngIf="!col.notInForm && addingForm?.get(col.field)">
              {{ col.header }}
              <input
                *ngIf="col.type === 'string' && col.isReadonly"
                [maxlength]="col.limit"
                [formControlName]="col.field"
                class="filter-text-search-input"
                pInputText
                type="text"
              />
              <input
                *ngIf="col.type === 'string' && col.accept === 'alphanumeric' && !col.isReadonly"
                [maxlength]="col.limit"
                [formControlName]="col.field"
                class="filter-text-search-input"
                pInputText
                type="text"
              />
              <input
                *ngIf="col.type === 'string' && col.accept === 'number' && !col.isReadonly"
                [maxlength]="col.limit"
                [formControlName]="col.field"
                class="filter-text-search-input"
                pInputText
                type="number"
                step="any"
              />
              <input
                *ngIf="col.type === 'number' && !col.isReadonly"
                type="text"
                class="filter-text-search-input"
                pInputText
                [formControlName]="col.field"
                (keypress)="onNumberKeyPress($event)"
              />
              <p-calendar
                *ngSwitchCase="'date'"
                [formControlName]="col.field"
                appendTo="body"
                dateFormat="dd/mm/yy"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="yearRange"
                [showIcon]="true"
                [autoZIndex]="true"
                [baseZIndex]="1000"
              ></p-calendar>
              <p-dropdown
                *ngSwitchCase="'bool'"
                [formControlName]="col.field"
                appendTo="body"
                [options]="booleanDataSet"
                [style]="{ width: '100%' }"
              ></p-dropdown>
              <p-dropdown
                *ngSwitchCase="'dropdown'"
                [formControlName]="col.field"
                appendTo="body"
                [options]="col.allowedInsertDataset"
                [style]="{ width: '100%' }"
              ></p-dropdown>
              <p-multiSelect
                *ngSwitchCase="'multiselect'"
                appendTo="body"
                [formControlName]="col.field"
                [options]="col.allowedInsertDataset"
                [defaultLabel]="col.default"
              ></p-multiSelect>
              <primeng-multiselect
                *ngSwitchCase="'multiselectcomplex'"
                [formControlName]="col.field"
                [setUrl]="col.setUrl"
                [columnset]="col.columnset"
                [addedParams]="col.addedComplexFieldsUrlParam['addRow']"
                [loadInitialData]="false"
                [isFilterOnly]="false"
                [isSingle]="col.isSingleSelect !== false"
                [useExistingDataOnly]="!col.isFilterBackendSearch"
                [allowMultipleFromSearch]="!col.isFilterSingleSelect"
                [baseMaxResults]="1000"
                [pageSize]="100"
                (onChange)="ConfigureMultiSelectFieldParams('addRow', '')"
              ></primeng-multiselect>
              <textarea
                *ngIf="col.type === 'textarea'"
                [formControlName]="col.field"
                rows="5"
                style="width: 100%; resize: vertical"
                pInputTextarea
              ></textarea>
            </div>
          </div>
          <button
            pButton
            icon="pi pi-plus"
            class="p-button-success"
            type="submit"
            label="Add"
          ></button>
        </form>
      </div>
    </p-dialog>

    <!-- Are you sure you want to delete that row dialog -->
    <p-dialog header="Are you sure?" [(visible)]="displayDelete">
      <div class="display-isloading" *ngIf="displayIsLoading">
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div class="delete-container" [ngClass]="displayIsLoading ? 'disable-form' : ''">
        <span>Are you sure you want to delete the selected rows?</span>
        <button
          pButton
          type="button"
          icon="pi pi-times"
          class="p-button-danger"
          (click)="displayDelete = false"
          label="No"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-check"
          class="p-button-success"
          (click)="onSelectDelete()"
          label="Yes"
        ></button>
      </div>
    </p-dialog>

    <!-- Advanced Filter dialog -->
    <p-dialog header="Advanced Filter" [(visible)]="displayAdvancedFilter">
      <div class="advanced-filter-container" [ngClass]="displayIsLoading ? 'disable-form' : ''">
        <input pInputText [formControl]="andvancedFilterInput" />
        <p-dropdown
          appendTo="body"
          [formControl]="advancedFilterType"
          [options]="matchModeDataSet"
          [style]="{ width: '100%' }"
        ></p-dropdown>
        <button
          pButton
          type="button"
          icon="pi pi-filter"
          class="p-button-success"
          (click)="onAdvancedFilter()"
          label="Filter"
        ></button>
      </div>
    </p-dialog>

    <!-- Dialog modal for editing the textarea -->
    <p-dialog
      header="Edit"
      [(visible)]="showTextAreaModal"
      [modal]="true"
      [style]="{
        width: '90vw',
        maxWidth: '600px',
      }"
      [baseZIndex]="10000"
      (onHide)="onTextAreaModalHide()"
    >
      <div>
        <textarea
          [(ngModel)]="textAreaModalValue"
          rows="10"
          style="width: 100%; resize: vertical"
          pInputTextarea
        ></textarea>
      </div>
      <ng-template pTemplate="footer">
        <button
          pButton
          label="Apply"
          (click)="applyTextAreaModal()"
          class="p-button-success"
        ></button>
      </ng-template>
    </p-dialog>
  </div>
</div>
